import type { Network } from "../types";

export const telegram: Network = {
  name: "Telegram",
  shareUrl: "https://t.me/share/url?url=[u]",
  args: {
    title: "&text=[t]",
  },
  icon: "/media/images/facebook-social-auth.svg",
  color: "#26A5E4",
};
